import { useCallback, useState } from "react";

import {
  Box,
  CircularProgress,
  Link,
  Stack,
  SxProps,
  TextField,
  Typography,
} from "@mui/material";

import { useAuth0 } from "@auth0/auth0-react";
import Lottie from "react-lottie-player";
import { toast } from "react-toastify";

import API from "api";

import EmailFloatingAnimation from "../../../../assets/lotties/emailFloating_branded.json";

const containerStyle: SxProps = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

const EmailVerification = () => {
  const { user, logout } = useAuth0();

  const [verificationLoading, setVerificationLoading] = useState(false);

  const resendVerificationEmail = useCallback(() => {
    if (verificationLoading) {
      return;
    }

    setVerificationLoading(true);
    API.User.resendVerification()
      .then(() => toast.info("Verification email sent"))
      .catch(() => {
        toast.error("Unable to resend verification email");
      })
      .finally(() => setVerificationLoading(false));
  }, [verificationLoading]);

  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <Box sx={containerStyle}>
        <Lottie
          play
          loop
          animationData={EmailFloatingAnimation}
          style={{
            height: 200,
          }}
        />
        <Typography variant="h4" my={4}>
          Verify your email address
        </Typography>
        <TextField
          error
          variant="outlined"
          value={user?.email}
          fullWidth
          disabled={true}
          style={{
            cursor: "not-allowed",
          }}
        />
        <Typography mt={2} mb={2} variant="body2" color="text.secondary">
          Your email address is not verified. Head over to your inbox to verify
          your email address and refresh this page to continue.
        </Typography>
        <Stack
          direction="column"
          // justifyContent={"space-between"}
          // alignItems="center"
          spacing={1}
          alignItems={"flex-start"}
        >
          <Box display="flex">
            <Link
              aria-disabled
              component="button"
              variant="body2"
              onClick={resendVerificationEmail}
              disabled={verificationLoading}
            >
              Resend verification email
            </Link>
            {verificationLoading && (
              <CircularProgress thickness={4} sx={{ ml: 1 }} size={20} />
            )}
          </Box>
          <Link
            sx={{ mt: 2 }}
            component="button"
            variant="body2"
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
          >
            Not you?
          </Link>
          <Link
            sx={{ mt: 2 }}
            component="button"
            variant="body2"
            onClick={() =>
              window.location.reload()
            }
          >
            Check Again
          </Link>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmailVerification;
